import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const opts = { withCredentials: true };
const btn = {
  padding: "8px 14px", borderRadius: 6, border: "1px solid #0f1b2d", background: "#0f1b2d",
  color: "#FFFFFF", fontSize: 13, fontWeight: 600, cursor: "pointer",
};

export const FinalQcReportSection = ({ orderId, allPassed }) => {
  const [run, setRun] = useState(null);
  const [err, setErr] = useState(null);
  const base = `${API}/api/super-admin/owner-actions/final-qc/${orderId}`;

  const load = useCallback(async () => {
    try { setRun((await axios.get(`${base}/latest`, opts)).data.run); } catch (e) { /* keep last state */ }
  }, [base]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (run?.status !== "running") return undefined;
    const iv = setInterval(load, 5000);
    return () => clearInterval(iv);
  }, [run, load]);

  const start = async () => {
    setErr(null);
    try { setRun((await axios.post(`${base}/run`, {}, opts)).data); }
    catch (e) { setErr(e?.response?.data?.detail || e.message); }
  };
  const download = async () => {
    const r = await axios.get(`${base}/pdf`, { ...opts, responseType: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(r.data);
    a.download = `Final_Quality_Report_${orderId}.pdf`;
    a.click();
  };

  const running = run?.status === "running";
  return (
    <div data-testid="final-qc-section" style={{ fontSize: 13, color: "#0f1b2d" }}>
      <p style={{ margin: "0 0 10px 0", color: "#475569" }}>
        Re-checks every finished drive from storage and produces the signed report you keep before shipping.
        Takes about 10–20 minutes.
      </p>
      {!allPassed && (
        <p data-testid="final-qc-not-ready" style={{ color: "#92400e" }}>
          Available once every drive has passed its 10-item checklist.
        </p>
      )}
      {allPassed && (
        <button data-testid="final-qc-run-btn" onClick={start} disabled={running}
          style={{ ...btn, opacity: running ? 0.6 : 1 }}>
          {running ? "Running quality report…" : run ? "Run the report again" : "Run final quality report"}
        </button>
      )}
      {run && run.status !== "running" && (
        <div style={{ marginTop: 10 }} data-testid="final-qc-result">
          <strong style={{ color: run.verdict === "PASS" ? "#047857" : "#b91c1c" }} data-testid="final-qc-verdict">
            {run.verdict === "PASS" ? "Passed: every drive checks out. Safe to ship." : "Did not pass. Do not ship yet; ask your builder to review."}
          </strong>
          {run.has_pdf && (
            <button data-testid="final-qc-download-btn" onClick={download}
              style={{ ...btn, marginLeft: 10, background: "#FFFFFF", color: "#0f1b2d" }}>
              Download signed report (PDF)
            </button>
          )}
        </div>
      )}
      {err && <p data-testid="final-qc-error" style={{ color: "#b91c1c", marginTop: 8 }}>{err}</p>}
    </div>
  );
};
